import React from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import { Provider } from 'react-redux';
import { persistor, store } from './stores/store';
import { PersistGate } from 'redux-persist/integration/react';

const children = (
	<ThemeContextProvider>
		<Provider store={store}>
			<PersistGate
				loading={null}
				persistor={persistor}
				onBeforeLift={() => {
					console.log('PersistGate has finished rehydrating.');
				}}>
				<Router>
					<React.StrictMode>
						<App />
					</React.StrictMode>
				</Router>
			</PersistGate>
		</Provider>
	</ThemeContextProvider>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
